<template>
  <div v-if="shouldShowBadge">
    <badge :type="getBadgeType()">
      {{ statusLabel }}
    </badge>
  </div>
</template>

<script>
import {
  CLIENT_VALIDATED_STATUS_DRAFT,
  CLIENT_VALIDATED_STATUS_PENDING,
  CLIENT_VALIDATED_STATUS_CANCELED,
  CLIENT_VALIDATED_STATUS_VALIDATED,
} from "@/constants/salesOrders";
import {
  ORDER_STATUS_CANCELED,
  ORDER_STATUS_VALIDATED,
} from "@/constants/orders";
import { salesOrderRequiresClientValidation } from "@/constants/pricingTypes";

export default {
  name: "sales-order-client-validated-status-badge",

  components: {},

  mixins: [],

  props: ["salesOrder"],

  data() {
    return {
      ORDER_STATUS_CANCELED,
      ORDER_STATUS_VALIDATED,
    };
  },

  computed: {
    clientValidationRequired() {
      return salesOrderRequiresClientValidation(this.salesOrder);
    },

    shouldShowBadge() {
      if (!this.clientValidationRequired) {
        return true;
      }

      // Show badge only if:
      // 1. Order is VALIDATED (sent to client)
      // 2. AND client_validated_status is not null and not DRAFT
      return (
        this.salesOrder.status === ORDER_STATUS_VALIDATED &&
        this.salesOrder.client_validated_status !== null &&
        this.salesOrder.client_validated_status !==
          CLIENT_VALIDATED_STATUS_DRAFT
      );
    },
    statusLabel() {
      if (!this.clientValidationRequired) {
        return this.$t("SALES_ORDERS.CLIENT_VALIDATED_STATUS_NOT_REQUIRED");
      }

      if (!this.salesOrder.client_validated_status) {
        return "";
      }

      // Check if it's a pending revision
      if (
        this.salesOrder.client_validated_status ===
          CLIENT_VALIDATED_STATUS_PENDING &&
        this.salesOrder.is_revision
      ) {
        return this.$t("SALES_ORDERS.CLIENT_VALIDATED_STATUS_PENDING_REVISION");
      }

      return this.$t(
        `SALES_ORDERS.CLIENT_VALIDATED_STATUS_${this.salesOrder.client_validated_status}`
      );
    },
  },

  methods: {
    getBadgeType() {
      if (!this.clientValidationRequired) {
        return "default";
      }

      switch (this.salesOrder.client_validated_status) {
        case CLIENT_VALIDATED_STATUS_PENDING:
          return "primary";
        case CLIENT_VALIDATED_STATUS_CANCELED:
          return "danger";
        case CLIENT_VALIDATED_STATUS_VALIDATED:
          return "success";
        default:
          break;
      }
      return "default";
    },
  },

  mounted() {},

  watch: {},
};
</script>
<style scoped>
.badge {
  max-width: 200px;
  line-height: 1.3;
  text-align: center;
  word-break: auto-phrase;
}

::v-deep .badge {
  white-space: normal !important;
  display: inline-block !important;
}
</style>
